import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilMass`]: wrap([
    `${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.ContainerMass`,
    `${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilAndContainerMass`,
  ]),
  [`${prefix}.InitialDrying.TestPortionDryMass`]: wrap([
    `${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.ContainerMass`,
    `${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.Measurements.TestPortionMass`]: wrap([
    `${prefix}.Measurements.FilterBowlMass`,
    `${prefix}.Measurements.FilterBowlTestPortionMass`,
  ]),
  [`${prefix}.Measurements.SolutionMass`]: wrap([
    `${prefix}.Measurements.FlaskStopperSolutionMass`,
    `${prefix}.Measurements.FlaskAndStopperMass`,
  ]),
  [`${prefix}.Measurements.Trials.MassOfBinder`]: wrap([
    `${prefix}.Measurements.Trials.ContainerAndLidMass`,
    `${prefix}.Measurements.Trials.ContainerLidAndLiquidMass`,
    `${prefix}.Measurements.Trials.ContainerLidAndResidueMass`,
  ]),
  [`${prefix}.Results.AggregateMass`]: wrap([
    `${prefix}.Measurements.Trials.ContainerAndLidMass`,
    `${prefix}.Measurements.Trials.ContainerLidAndLiquidMass`,
    `${prefix}.Measurements.Trials.ContainerLidAndResidueMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
